<div class="container">
  <app-menu-page-header>
    <div class="head-left">
      <app-menu-page-title title="{{'NAV.MENU' | translate}}"></app-menu-page-title>
      <app-menu-page-search
        (keyup)="changeSearchQuery($event)"
        [ngModelOptions]="{standalone: true}"
        [ngModel]="searchQuery"
        [value]="searchQuery"
        searchLabel="{{ 'COMMON.SEARCH' | translate}}"
      ></app-menu-page-search>
    </div>
    <div class="head-right">
      <!--      <button mat-button>{{'MENU.PUBLISH_ALL' | translate}}</button>-->
      <!--      <button [matMenuTriggerFor]="newMenu" mat-button>{{'MENU.NEW_MENU' | translate}}</button>-->
      <app-help-button></app-help-button>
      <mat-menu #newMenu="matMenu">
        <button (click)="createMenuSection()" mat-menu-item>{{'MENU.JUST_NEW' | translate}}</button>
        <button [matMenuTriggerFor]="anotherMenu" mat-menu-item>{{'MENU.DUPLICATE_FROM' | translate}}</button>
      </mat-menu>

      <mat-menu #anotherMenu="matMenu">
        <button *ngFor="let menuSection of menuSections" mat-menu-item>{{ menuSection.name }}</button>
      </mat-menu>
    </div>
  </app-menu-page-header>

  <app-preloader [show]="getMenusPending$ | async">
    <router-outlet *ngIf="this.dataIsLoaded"></router-outlet>
  </app-preloader>

  <div *ngIf="this.dataIsLoaded && !menuSections?.length" class="no-data-block">{{ 'MENU.NO_DATA_TO_DISPLAY' | translate }}</div>
</div>
